import {useState} from 'react'
import {css} from '@emotion/react'
import {HistoryOutlined} from '@ant-design/icons'
import {InputText, TextArea} from '@/components/Form'
import {Alert, Modal, useOpenModal} from '@/components/Modal'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import useSwr from '@/script/useSwrNoCache.mjs'
import {DraftIconButton, useAiContext} from './core'

const usePromptHistory = usageScenarioCode => {
    return useSwr(
        () => runAsync(
            () => http.get(
                '/llmUserPromptHistory/listLlmUserPromptHistory',
                {usageScenarioCode}
            ),

            {action: '读取提示词历史'}
        ),

        {dependencies: [usageScenarioCode]}
    )
}

const cssHistory = css({
    display: 'grid',
    gridTemplateColumns: '240px auto',
    gridTemplateRows: 'auto 1fr',
    overflow: 'hidden',
})

const cssInput = css({
    gridArea: '1 / 1 / 2 / 2',
    display: 'flex',
    width: 'auto',
    borderRadius: 4,
    margin: '12px 0 12px 12px',
})

const cssHistoryItems = css({
    gridArea: '2 / 1 / 3 / 2',
    display: 'grid',
    gridAutoRows: 'min-content',
    borderRight: '1px solid #f0f0f0',
    overflow: 'auto',
})

const cssHistoryItem = css({
    display: 'grid',
    gap: 4,
    padding: '8px 16px',
    borderBottom: '1px solid #f0f0f0',
    userSelect: 'none',

    '&:hover': {
        backgroundColor: '#efefef',
    },
})

const cssHistoryBrief = css({
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
})

const cssHistoryTime = css({
    justifySelf: 'end',
    fontSize: 11,
    color: '#bbb',
})

const cssHistoryContent = css({
    gridArea: '1 / 2 / 3 / 3',
    display: 'grid',
    padding: 16,
    overflow: 'hidden',

    'textarea': {
        height: 'auto !important'
    },
})

const HistoryItem = ({content, crtTime, onClick, ...props}) => {
    const _onClick = () => {
        navigator.clipboard.writeText(content)
        onClick()
    }

    return (
        <div
            css={cssHistoryItem}
            onClick={_onClick}
            {...props}
        >
            <div css={cssHistoryBrief}>{content}</div>
            <div css={cssHistoryTime}>{crtTime}</div>
        </div>
    )
}

const ModalPromptHistory = ({scene, ...props}) => {
    const [currentPrompt, setCurrentPrompt] = useState()
    const [query, setQuery] = useState('')
    const {data = []} = usePromptHistory(scene)
    const re = new RegExp(RegExp.escape(query))

    const prompts = data
        .filter(p => re.test(p.promptContent))
        .map(p => (
            <HistoryItem
                crtTime={p.crtTime}
                content={p.promptContent}
                key={p.crtTime}
                onClick={() => setCurrentPrompt(p)}
            />
        ))

    if (
        query ||
        0 < prompts.length
    ) {
        return (
            <Modal
                bodyStyle={{padding: 0}}
                noCancelButton
                title="提示词历史"
                width={1200}
                height="100vh"
                {...props}
            >
                <div css={cssHistory}>
                    <InputText
                        css={cssInput}
                        allowClear
                        focus
                        placeholder="搜索"
                        onChange={setQuery}
                    />

                    <div css={cssHistoryItems}>
                        {prompts}
                    </div>

                    <div css={cssHistoryContent}>
                        {
                            currentPrompt &&

                            <TextArea
                                readOnly
                                value={currentPrompt?.promptContent}
                            />
                        }
                    </div>
                </div>
            </Modal>
        )
    }
    else {
        return (
            <Alert type="warn" {...props}>
                未找到历史记录
            </Alert>
        )
    }
}

export const ButtonPromptHistory = (props) => {
    const openModal = useOpenModal()
    const ai = useAiContext()
    const onClick = () => openModal(<ModalPromptHistory scene={ai.scene} />)

    return (
        <DraftIconButton
            title="提示词历史..."
            onClick={onClick}
            {...props}
        >
            <HistoryOutlined />
        </DraftIconButton>
    )
}
